

import { framework_tool, utils_tool, component_tool } from '@/tool'
let { Session } = utils_tool;
import { modelUtils } from '@/utils'

import React from 'react';
import { connect } from 'dva';
import TaskForm from './taskForm';
let { copy } = utils_tool
let { WizCard, WizModal, WizUpload, WizSpin, WizRow, WizButton, WizTypography, WizCopyModal, Wizmessage, WizInput } = component_tool;
let { WizContainer } = framework_tool;

class TaskEdit extends WizContainer {


  constructor(props) {
    super(props);
    const { history } = props;
    let record = {};
    let pageType = 'add'

    // 如果是编辑页面，则缓存来自列表页的这条记录，避免刷新页面之后字段被销毁。
    if (history.location && history.location.pathname === '/taskInfo/update') {
      if (history.location && history.location.record) {
        record = history.location.record;
        Session.set('TaskInfo', record)
      } else {
        record = Session.get('TaskInfo') || {};
      }
      pageType = 'upd';
    }
    this.state = {
      record: record,
      initialValue: {}
    }
    this.pageType = pageType;
  }

  _componentDidMount = () => {
    let {record} = this.state
    if (record && record.id) {
      this.doAction({
        path: "taskInfo/editInfo",
        payload: {
          key: "taskInfo@editInfo",
          apiParams: { id: record.id }
        }
      });
    }
  };

  propsAndStateOnChange = {
    taskInfoSave: this._save.bind(this),
    taskInfoEdit: this._reLoad.bind(this)
  }
  changeRuleId(data) {
    this.doAction({
      path: "taskInfo/editInfo",
      payload: {
        key: "taskInfo@editInfo",
        apiParams: { id: data }
      }
    });
  }
  _reLoad(nextProps, nextState) {
    if (nextProps.taskInfoEdit.code == 1) {
      this.pageType = 'upd'
      nextState['record'] = nextProps.taskInfoEdit.data
    }
    else {
      wizNotice.error('获取任务信息失败：' + nextProps.taskInfoEdit.msg);
    }
    return true;
  }
  _save(nextProps, nextState) {
    if (nextProps.taskInfoSave.code == 1) {
      WizModal.confirm({
        title: "是否进入通知设置？",
        onOk: () => {
          this.jumpPage('replace', '/taskInfo/taskNotice', {id:nextProps.taskInfoSave.data});
        },
        onCancel: () => {
          this.jumpPage('replace', '/taskInfo');
        }
      });
    } else if (nextProps.taskInfoSave.code == 100101) {
      let str = nextProps.taskInfoSave.msg
      WizModal.confirm({
        title: str + "，是否跳转到编辑页？",
        onOk: () => {
          nextState['ruleId'] = nextProps.taskInfoSave.data
          this.changeRuleId(nextProps.taskInfoSave.data)
        },
        onCancel() {
        }
      });
      return false
    } else {
      wizNotice.error('提交失败：' + nextProps.taskInfoSave.msg);
    }
    return true;
  }

  _submit = (apiParams) => {
    if (this.pageType === 'add') {
      apiParams.status = 1
    }
    this.doAction({
      path: this.pageType === 'add' ? "taskInfo/add" : "taskInfo/upd",
      payload: {
        key: "taskInfo@save",
        apiParams: apiParams
      }
    });
  }

  _render() {
    let title = this.state.ruleId ? "修改任务" : "新增任务"
    return (
      <>
        <WizCard>
          <WizSpin tip={"加载中"} spinning={this.props.taskInfoLoading}>
            <TaskForm key={this.state.ruleId} submit={(v) => { this._submit(v) }} data={this.state.record} />
          </WizSpin>
        </WizCard>
      </>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const { taskInfo } = state;

  const taskInfoSave = modelUtils.getModelEntity(taskInfo, "taskInfo@save");
  const taskInfoEdit = modelUtils.getModelEntity(taskInfo, "taskInfo@editInfo");
  const load = modelUtils.getLoadingState(state, "taskInfo");
  return {
    taskInfoSave,
    taskInfoEdit,
    ...load
  };
};

export default connect(mapStateToProps)(TaskEdit);
